<template>
  <div>
    
      <b-pagination
        v-model="currentPage"
        :total-rows="rates.length"
        :per-page="perPage"
        class="my-4"
      ></b-pagination>
      <b-table
        :items="rates"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        stacked="md"
        show-empty
        small
      >
        <template #cell(index)="data">
          {{ ((currentPage - 1 ) * perPage) + data.index + 1 }}
        </template>
        <template #cell(actions)="data">
          <b-button v-b-tooltip.hover size="sm"  @click="getRate(data.item)" variant="outline-primary" title="Editar">
            <font-awesome-icon :icon="['fas', 'edit']"/>
          </b-button>
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="rates.length"
        :per-page="perPage"
        class="my-4"
      ></b-pagination>
    <rate-edit-admin v-if="selectedRate" :isOpen="isOpenEditRate" :rate="selectedRate" @close-edit-rate="closeEditRate"></rate-edit-admin>
  </div>
</template>
<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import RateEditAdmin from './RateEditAdmin.vue'
  export default {
    name:'RatesListAdmin',
    components:{ FontAwesomeIcon, RateEditAdmin },
    props:['filters', 'rates'],
    data() {
      return {
        currentPage: 1,
        perPage: 15,
        selectedRate: null,
        isOpenEditRate: false,
        fields: [
          'index',
          { key: 'destination', label: 'Destino'},
          { key: 'destination', label: 'Destino'},
          { key: 'service', label: 'Producto'},
          { key: 'ow', label: 'OW'},
          { key: 'rt', label: 'RT'},
          { key: 'mxn', label: 'MXN'},
          { key: 'actions', label: 'Actions' }
        ],
      }
    },
    mounted() {
    },
    methods:{
      urlEdit(i) {
        return `${process.env.MIX_APP_URL}${this.$prefixPanel}/rates/${i.id}`
      },
      closeEditRate(e) {
        console.log('test', e);
        
        this.isOpenEditRate = e
      },
      getRate(item) {
        console.log('item', item);
        this.selectedRate = item
        this.isOpenEditRate = true
        
      }
    }
  }
</script>